import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import { auth, db } from "../firebase";

const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
    return res;
  } catch (err: any) {
    console.error(err);
    throw err;
  }
};

export const getUser = async (uid: string) => {
  try {
    const q = query(collection(db, "users"), where("uid", "==", uid));
    const docs = await getDocs(q);
    if (docs.docs.length > 0) {
      return { ...docs.docs[0].data(), id: docs.docs[0].id };
    }
    return null;
  } catch (err) {
    console.error("Error fetching user", err);
    throw err;
  }
};

export const logout = () => {
  signOut(auth)
    .then(() => { })
    .catch((err) => console.error(err));
};
